<script>
  import {previewUrlForVideo} from "./services/imageService";
  import {createEventDispatcher} from 'svelte';
  import {update_video} from "./Utils/RouterUtils.svelte"
  export let video = null
  const dispatch = createEventDispatcher();

  import {fade} from 'svelte/transition';

  function videoClicked() {
    dispatch('video-clicked');
  }
</script>
{#if video.video}
  <div
    id={video.video.slug.current}
    class="mb-5"
    in:fade="{{delay: 0,  duration: 200}}"
    on:click={update_video(video.video.slug.current), videoClicked()}>
    <div class="vec-flex vec-flex-col vec-space-y-4 vec-mb-5 xl:vec-mr-5 vec-cursor-pointer">
        <div class="vec-relative vec-rounded-xl vec-rounded-bl-none vec-border vec-border-midGrey vec-overflow-hidden">
          <img src="{previewUrlForVideo(video.video)}" alt="{video.video.videoTitle}" class=""/>
        </div>
        <div class="vec-flex vec-flex-col vec-space-y-2">
            <h3>{video.video.videoTitle}</h3>
            <p>{video.video.shortDescription}</p>
          </div>
    </div>
  </div>
{:else}
  <div
    id={video.slug.current}
    class="mb-5"
    in:fade="{{delay: 0,  duration: 200}}"
    on:click={update_video(video.slug.current), videoClicked()}>
    <div class="vec-flex vec-flex-col vec-space-y-4 vec-mb-5 xl:vec-mr-5 vec-cursor-pointer">
      <div class="vec-relative vec-rounded-xl vec-rounded-bl-none vec-border vec-border-midGrey vec-overflow-hidden">
          <img src="{previewUrlForVideo(video)}" alt="{video.videoTitle}" class=""/>
        </div>
          <div class="vec-space-y-2">
            <h3>{video.videoTitle}</h3>
            <p>{video.shortDescription}</p>
          </div>
    </div>
  </div>
{/if}
